const r=(r,n,t)=>{if(!r)return t;const o=Array.isArray(n)?n:[n],s={};for(const n in r)o.includes(n)||(s[n]=r[n]);return s};export{r as omit};
